import { Injectable } from '@angular/core';
import * as Rx from 'rxjs/Rx';

@Injectable()
export class WebsocketService {
	constructor() { }

	private subject: Rx.Subject<MessageEvent>;
	private ws;

	public connect(url, WSToken): Rx.Subject<MessageEvent> {
		if (!this.subject) {
			this.subject = this.create(url, WSToken);
			console.log("Successfully connected: " + url);
		} 
		return this.subject;
	}

	private create(url, WSToken): Rx.Subject<MessageEvent> {
		this.ws = new WebSocket(url);
		
		let ws = this.ws;

		let observable = Rx.Observable.create(
		(obs: Rx.Observer<MessageEvent>) => {
			ws.onmessage = obs.next.bind(obs);
			ws.onerror = function(error){
				console.log("erreur websocket :")
				console.log(error);
			}
			ws.onclose = function(close){
				console.log("close connection :")
				console.log(close);
			}

			return ws.close.bind(ws);
		});
		let observer = {
			next: (data: Object) => {
				var cpt = 0;
				let interval = setInterval(function(){
					cpt++;
					if (cpt < 5){
						if (ws.readyState === WebSocket.OPEN) {
							ws.send(JSON.stringify(data));

							clearInterval(interval);
						}
					}
					else {
						clearInterval(interval);
					}
				}, 200);
				
			}
		}
		return Rx.Subject.create(observer, observable);
	}

	public close(){
		console.log("close websocket");
		this.ws.close();
		this.subject = null;
		
	}

}


// WEBPACK FOOTER //
// ./src/providers/websocket/websocket.ts